// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"aws":"50fabebe","lsc":"3a90cba0","others":"9fe81b0c"}[chunkId] + ".chunk.js";
};